var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description"},[_c('p',{staticClass:"description-content",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('div',{staticClass:"description-button-container"},[_c('button',{staticClass:"description-button-container-button",on:{"click":_vm.onAgree}},[_vm._v(" 已阅读并同意 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }